import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260611_roof_block_instance_ref",
  description: "Migrates roof blocks from string references to RoofBlockInstanceRef objects",
  apply(json: any) {
    if (!json.roofs) {
      return json;
    }

    for (const roofId in json.roofs) {
      const roof = json.roofs[roofId];
      if (!roof.blocks) {
        continue;
      }

      if (typeof roof.blocks === "object" && roof.blocks.type === "VIRTUAL_ROOF_BLOCK") {
        continue;
      }

      if (typeof roof.blocks === "string") {
        roof.blocks = { entityId: roof.blocks };
      } else if (Array.isArray(roof.blocks)) {
        roof.blocks = roof.blocks.map((blockRef: any) => {
          if (typeof blockRef === "string") {
            return { entityId: blockRef };
          }
          return blockRef;
        });
      }
    }

    return json;
  },
};

export default migration;
